import { render, staticRenderFns } from "./EventModalForm.vue?vue&type=template&id=70ede262&"
import script from "./EventModalForm.vue?vue&type=script&lang=js&"
export * from "./EventModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports